import { InjectionToken } from '@angular/core';

import { MedicalDocumentsLibConfig } from '../models/medical-documents-config.interface';

export const MD_LIB_CONFIG = new InjectionToken<MedicalDocumentsLibConfig>('MD_LIB_CONFIG');
export const MD_API_URL = new InjectionToken<string>('MD_API_URL');
